(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    /*
    Product opened from a vehicle's results: product cards on a vehicle-filtered
    collection add the vehicle's filters to the product link. Liquid cannot read
    a product URL's query string, so the collection crumb is swapped for the
    vehicle here: Home / 2018 Ford F-150 / Product. It is read from this page's
    own URL, so the trail is the same however the link was reached.
  */
  (function () {
    function applyVehicle(nav) {
      var data = nav.querySelector('script[data-breadcrumbs-vehicle]');
      if (!data) return;
      var config;
      try {
        config = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }
      var query = new URLSearchParams(window.location.search);
      var pairs = [];
      var labels = [];
      (config.params || []).filter(Boolean).forEach(function (param) {
        var value = query.get(param);
        if (!value) return;
        pairs.push([param, value]);
        labels.push(value);
      });
      if (!labels.length) return;

      var current = nav.querySelector('[data-crumb-kind="current"]');
      if (!current) return;
      var item = nav.querySelector('[data-crumb-kind="collection"]');
      if (!item) {
        item = document.createElement('li');
        item.className = 'breadcrumbs__item';
        var separator = current.querySelector('.breadcrumbs__separator');
        if (separator) item.appendChild(separator.cloneNode(true));
        current.parentNode.insertBefore(item, current);
      }
      item.setAttribute('data-crumb-kind', 'vehicle');
      var link = document.createElement('a');
      link.href = config.resultsUrl + '?' + new URLSearchParams(pairs).toString();
      link.textContent = labels.join(' ');
      var old = item.querySelector('a, span:not(.breadcrumbs__separator)');
      if (old) {
        item.replaceChild(link, old);
      } else {
        item.appendChild(link);
      }
    }

    function init() {
      document.querySelectorAll('[data-breadcrumbs-product]').forEach(applyVehicle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-hierarchy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hierarchy-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var children = this.closest('.collection-hierarchy__item').querySelector(':scope > .collection-hierarchy__children');
      if (!children) return;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      children.hidden = expanded;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-newsletter-form"] && !Shopify.designMode) return;
  try {
    (function newsletterForms() {
    var MESSAGE = '[data-newsletter-message]';

    function init() {
      scopeMessages();
      dropPostedParam();
      Array.prototype.forEach.call(
        document.querySelectorAll('form[data-newsletter-form]'),
        enhance
      );
    }

    // Shopify sends every customer form on the page the same posted/error
    // state, and the footer can render several at once. The redirect carries
    // the posting form's id as the URL fragment, so hide the messages that
    // are not its own.
    function scopeMessages() {
      var id = window.location.hash.slice(1);
      if (!id) return;

      var messages = document.querySelectorAll(MESSAGE);
      if (!messages.length) return;

      var owner = false;
      Array.prototype.forEach.call(messages, function (el) {
        if (el.dataset.newsletterForm === id) owner = true;
      });
      // An unrelated fragment tells us nothing; leave every message visible.
      if (!owner) return;

      Array.prototype.forEach.call(messages, function (el) {
        if (el.dataset.newsletterForm !== id) el.hidden = true;
      });
    }

    // A form that posted without JavaScript lands back here on
    // ?customer_posted=true, so every later reload re-renders the thank you
    // message. This view already has the message in the DOM, so the parameter
    // has done its job: drop it and leave a clean URL to refresh.
    function dropPostedParam() {
      if (window.location.search.indexOf('customer_posted=') === -1) return;
      if (!window.history || !window.history.replaceState || !window.URL) return;

      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      // The fragment stays: other sections read it to restore their state.
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function canPost() {
      return !!(window.fetch && window.FormData && window.DOMParser);
    }

    function isEnhanced(form) {
      return form instanceof HTMLFormElement && form.__newsletterEnhanced === true;
    }

    function enhance(form) {
      if (!canPost()) return;
      form.__newsletterEnhanced = true;
      // Shopify's bot protection holds the submit event back while it fetches
      // a captcha token, then sends the form itself with form.submit(), which
      // fires no submit event and would reload the page. Route that call
      // through the background post too, token included.
      form.submit = function () {
        post(form);
      };
    }

    // Covers HTMLFormElement.prototype.submit.call(form), which skips the
    // per-form override above.
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (isEnhanced(this)) {
        post(this);
        return;
      }
      return nativeSubmit.call(this);
    };

    // Listening on window runs after the form's and the document's own
    // listeners. When the captcha script has already cancelled the event it
    // will submit again once it has a token, so leave this one to it.
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!isEnhanced(form) || event.defaultPrevented) return;
      event.preventDefault();
      post(form);
    });

    // Posting in the background keeps the page and the scroll position where
    // they are, and never puts ?customer_posted=true in the URL. The response
    // is the page Shopify would have redirected to, so the message it rendered
    // for this form is the one to show.
    function post(form) {
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      // A later submit (the captcha's, carrying its token) supersedes one
      // still in flight.
      var request = (form.__newsletterRequest || 0) + 1;
      form.__newsletterRequest = request;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (request !== form.__newsletterRequest) return;

          // Shopify wants a visible captcha, which only works as a full page.
          // Send the form natively; it comes back to the thank you message.
          if (response.url && response.url.indexOf('/challenge') !== -1) {
            nativeSubmit.call(form);
            return;
          }
          if (!response.ok) throw new Error('Newsletter post failed: ' + response.status);

          return response.text().then(function (html) {
            if (request !== form.__newsletterRequest) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var message = doc.querySelector(
              MESSAGE + '[data-newsletter-form="' + form.dataset.newsletterForm + '"]'
            );

            if (message && message.getAttribute('data-newsletter-status') === 'success') {
              showSuccess(form, message, button);
              return;
            }
            showError(form, message, button);
          });
        })
        .catch(function () {
          if (request !== form.__newsletterRequest) return;
          showError(form, null, button);
        });
    }

    // Unlike the server render, keep the field so another address can be
    // added: clear it and show the message below it.
    function showSuccess(form, message, button) {
      var existing = form.querySelector(MESSAGE);
      if (existing) existing.parentNode.removeChild(existing);

      var node = document.importNode(message, true);
      node.hidden = false;
      node.classList.add('newsletter-form__message--below');
      form.appendChild(node);

      var input = form.querySelector('input[type="email"]');
      if (input) {
        input.value = '';
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      }
      if (button) button.disabled = false;
    }

    function showError(form, message, button) {
      var existing = form.querySelector(MESSAGE);
      if (existing) existing.parentNode.removeChild(existing);

      var node;
      if (message) {
        node = document.importNode(message, true);
      } else {
        node = document.createElement('div');
        node.className = 'newsletter-form__message newsletter-form__message--error';
        node.setAttribute('role', 'alert');
        node.setAttribute('data-newsletter-message', '');
        node.setAttribute('data-newsletter-status', 'error');
        node.textContent = form.dataset.newsletterError || '';
      }

      node.hidden = false;
      form.insertBefore(node, form.firstChild);

      var input = form.querySelector('input[type="email"]');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        if (node.id) input.setAttribute('aria-describedby', node.id);
        input.focus();
      }
      if (button) button.disabled = false;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const sync = (wrapper) => {
      const toggle = wrapper.querySelector('[data-gift-card-recipient-toggle]');
      const fields = wrapper.querySelector('[data-gift-card-recipient-fields]');
      if (!toggle || !fields) return;
      fields.disabled = !toggle.checked;
      fields.hidden = !toggle.checked;
      const offset = fields.querySelector('[data-gift-card-recipient-offset]');
      if (offset) offset.value = String(new Date().getTimezoneOffset());
    };

    const init = () => document.querySelectorAll('[data-gift-card-recipient]').forEach(sync);

    document.addEventListener('change', (event) => {
      const toggle = event.target.closest && event.target.closest('[data-gift-card-recipient-toggle]');
      if (toggle) sync(toggle.closest('[data-gift-card-recipient]'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('quick-view:loaded', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /*
    Subscription options: the chosen plan re-prices the product, and a variant
    change re-prices every plan and disables the ones it does not cover. The
    plain variant price comes back from the variant <option> (or, on a product
    with no variants, from the price shown on load).
  */
  (() => {
    const readPrices = (radio) => {
      try {
        return JSON.parse(radio.dataset.prices || '{}');
      } catch (error) {
        return {};
      }
    };

    const update = (form) => {
      const fieldset = form.querySelector('[data-selling-plans]');
      if (!fieldset) return;
      const variantInput = form.querySelector('[name="id"]');
      const variantId = variantInput ? String(variantInput.value) : '';
      const radios = Array.from(fieldset.querySelectorAll('[data-selling-plan-option]'));

      radios.forEach((radio) => {
        if (!radio.value) return;
        const entry = readPrices(radio)[variantId];
        radio.disabled = !entry;
        const priceText = radio.closest('label')?.querySelector('[data-selling-plan-price]');
        if (priceText) priceText.innerHTML = entry ? entry.price : '';
      });

      let checked = radios.find((radio) => radio.checked);
      if (!checked || checked.disabled) {
        const fallback = radios.find((radio) => !radio.disabled);
        if (fallback) fallback.checked = true;
        checked = fallback;
      }

      const wrap = form.closest('[data-product], .product') || form;
      const priceEl = wrap.querySelector('[data-price]');
      const compareEl = wrap.querySelector('[data-compare-price]');
      if (!priceEl) return;
      if (priceEl.dataset.basePrice === undefined) {
        priceEl.dataset.basePrice = priceEl.innerHTML;
        priceEl.dataset.baseCompare = compareEl ? compareEl.innerHTML : '';
      }

      const option = variantInput && variantInput.selectedOptions ? variantInput.selectedOptions[0] : null;
      let price = option ? option.dataset.price : priceEl.dataset.basePrice;
      let compare = option ? option.dataset.compare || '' : priceEl.dataset.baseCompare;
      const entry = checked && checked.value ? readPrices(checked)[variantId] : null;
      if (entry) {
        price = entry.price;
        compare = entry.compare || '';
      }
      priceEl.innerHTML = price;
      if (compareEl) {
        compareEl.innerHTML = compare;
        compareEl.hidden = !compare;
      }
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[data-selling-plan-option]')) {
        update(target.form);
        return;
      }
      // The variant script updates the price on the same event; run after it.
      const select = target.closest('[data-variant-select]');
      if (select && select.form) setTimeout(() => update(select.form), 0);
    });

    const init = () => {
      document.querySelectorAll('[data-selling-plans]').forEach((fieldset) => {
        if (fieldset.closest('form')) update(fieldset.closest('form'));
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('quick-view:loaded', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    /*
    3D models: media_tag outputs <model-viewer>, but the viewer library, its
    controls and AR ("View in your space") come from Shopify's features, which
    have to be loaded. Runs again when the theme editor re-renders a section and
    when quick view injects a product, so a gallery added later works too.
  */
  (() => {
    let xrReady = false;

    const setupModels = () => {
      document.querySelectorAll('.product__gallery model-viewer').forEach((viewer) => {
        if (viewer.dataset.modelUiReady) return;
        viewer.dataset.modelUiReady = 'true';
        try {
          new window.Shopify.ModelViewerUI(viewer);
        } catch (error) {
          // The viewer still renders without the controls.
        }
      });
    };

    const setupXr = () => {
      if (!window.ShopifyXR) return;
      document.querySelectorAll('[data-product-models]').forEach((list) => {
        if (list.dataset.xrAdded) return;
        list.dataset.xrAdded = 'true';
        try {
          window.ShopifyXR.addModels(JSON.parse(list.textContent));
        } catch (error) {
          // A bad list only costs the AR button.
        }
      });
      window.ShopifyXR.setupXRElements();
    };

    const load = () => {
      if (!document.querySelector('.product__gallery model-viewer, [data-product-models]')) return;
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      if (xrReady) {
        setupModels();
        setupXr();
        return;
      }
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (error) => {
            if (!error) setupModels();
          },
        },
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: (error) => {
            if (error) return;
            xrReady = true;
            if (window.ShopifyXR) {
              setupXr();
            } else {
              document.addEventListener('shopify_xr_initialized', setupXr, { once: true });
            }
          },
        },
      ]);
    };

    // Point "View in your space" at the model the shopper chose.
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest && event.target.closest('[data-thumb][data-media-type="model"]');
      if (!thumb) return;
      const button = thumb.closest('.product__gallery')?.querySelector('[data-xr-button]');
      if (button) button.setAttribute('data-shopify-model3d-id', thumb.dataset.mediaId);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', load);
    } else {
      load();
    }
    document.addEventListener('shopify:section:load', load);
    document.addEventListener('quick-view:loaded', load);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-discovery-filters"] && !Shopify.designMode) return;
  try {
    (function() {
    // Dispatches a cancelable event first so collection-ajax.js can take over;
    // without it (or on other pages) the form submits as a normal GET reload.
    // Re-callable after AJAX swaps replace the filter inputs.
    // Keeps the dual-handle slider and the min/max number inputs in sync. The
    // sliders carry no name, so only the number inputs reach the query string.
    var bindPrice = function(price) {
      if (price.dataset.sdBound) return;
      price.dataset.sdBound = 'true';

      var ceiling = parseFloat(price.getAttribute('data-ceiling')) || 0;
      var fill = price.querySelector('[data-sd-price-fill]');
      var summary = price.querySelector('[data-sd-price-summary]');
      var sliders = {
        min: price.querySelector('[data-sd-price-slider="min"]'),
        max: price.querySelector('[data-sd-price-slider="max"]')
      };
      var inputs = {
        min: price.querySelector('[data-sd-price-input="min"]'),
        max: price.querySelector('[data-sd-price-input="max"]')
      };
      if (!ceiling || !fill || !sliders.min || !sliders.max || !inputs.min || !inputs.max) return;

      var clamp = function(value) { return Math.min(Math.max(value, 0), ceiling); };
      var readInput = function(key) {
        var raw = parseFloat(inputs[key].value);
        if (isNaN(raw)) return key === 'min' ? 0 : ceiling;
        return clamp(raw);
      };

      var money = function(value) {
        var symbol = summary ? summary.getAttribute('data-symbol') || '' : '';
        return symbol + (value % 1 === 0 ? String(value) : value.toFixed(2));
      };

      var paint = function(from, to) {
        fill.style.insetInlineStart = (from / ceiling) * 100 + '%';
        fill.style.width = ((to - from) / ceiling) * 100 + '%';
        if (!summary) return;
        var template = summary.getAttribute('data-template');
        if (template) summary.textContent = template.replace('[min]', money(from)).replace('[max]', money(to));
      };

      var syncFromSliders = function(moved) {
        var from = clamp(parseFloat(sliders.min.value));
        var to = clamp(parseFloat(sliders.max.value));
        if (from > to) {
          if (moved === 'min') from = to; else to = from;
          sliders[moved].value = moved === 'min' ? from : to;
        }
        inputs.min.value = from === 0 ? '' : String(from);
        inputs.max.value = to === ceiling ? '' : String(to);
        paint(from, to);
      };

      var syncFromInputs = function() {
        var from = readInput('min');
        var to = readInput('max');
        if (from > to) from = to;
        sliders.min.value = String(from);
        sliders.max.value = String(to);
        paint(from, to);
      };

      sliders.min.addEventListener('input', function() { syncFromSliders('min'); });
      sliders.max.addEventListener('input', function() { syncFromSliders('max'); });
      inputs.min.addEventListener('input', syncFromInputs);
      inputs.max.addEventListener('input', syncFromInputs);

      syncFromInputs();
      price.classList.add('is-ready');
    };

    var bind = function() {
      document.querySelectorAll('[data-sd-filters]').forEach(function(form) {
        var submit = function() {
          window.clearTimeout(form.sdSubmitTimer);
          form.sdSubmitTimer = window.setTimeout(function() {
            var proceed = form.dispatchEvent(new CustomEvent('collection:filter-change', { bubbles: true, cancelable: true }));
            if (proceed) form.submit();
          }, 180);
        };
        // Enter and the apply button submit natively; route them through the
        // same cancelable event so AJAX can take over.
        if (!form.dataset.sdFormBound) {
          form.dataset.sdFormBound = 'true';
          form.addEventListener('submit', function(event) {
            var proceed = form.dispatchEvent(new CustomEvent('collection:filter-change', { bubbles: true, cancelable: true }));
            if (!proceed) event.preventDefault();
          });
        }

        form.querySelectorAll('input[type="checkbox"]:not(.sd-filter__more-toggle)').forEach(function(input) {
          if (input.dataset.sdBound) return;
          input.dataset.sdBound = 'true';
          input.addEventListener('change', submit);
        });

        form.querySelectorAll('[data-sd-price]').forEach(bindPrice);

        // "Clear" empties one group's own inputs, then re-submits. Shopify
        // exposes no per-filter reset URL, and the form is the source of truth.
        form.querySelectorAll('[data-sd-clear]').forEach(function(button) {
          if (button.dataset.sdBound) return;
          button.dataset.sdBound = 'true';
          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            var group = button.closest('.sd-filter');
            if (!group) return;
            group.querySelectorAll('input[type="checkbox"]:not(.sd-filter__more-toggle)').forEach(function(input) {
              input.checked = false;
            });
            group.querySelectorAll('input[type="number"]').forEach(function(input) {
              input.value = '';
            });
            submit();
          });
        });

        form.querySelectorAll('[data-sd-search]').forEach(function(input) {
          if (input.dataset.sdBound) return;
          input.dataset.sdBound = 'true';
          var group = input.closest('.sd-filter');
          var values = group && group.querySelector('.sd-filter__values');
          if (!values) return;
          var options = Array.prototype.slice.call(values.querySelectorAll('.sd-filter__value'));

          input.addEventListener('input', function() {
            var term = input.value.trim().toLowerCase();
            values.classList.toggle('is-searching', term !== '');
            var matches = 0;
            options.forEach(function(option) {
              var label = option.textContent.trim().toLowerCase();
              var hit = term === '' || label.indexOf(term) !== -1;
              option.hidden = !hit;
              if (hit) matches += 1;
            });
            var empty = group.querySelector('.sd-filter__empty');
            if (matches === 0 && term !== '') {
              if (!empty) {
                empty = document.createElement('p');
                empty.className = 'sd-filter__empty';
                values.insertAdjacentElement('afterend', empty);
              }
              empty.textContent = input.dataset.emptyText || 'No matches';
            } else if (empty) {
              empty.remove();
            }
          });
        });
      });
    };
    bind();
    window.initSDFilters = bind;
    document.addEventListener('shopify:section:load', bind);
  })();
  } catch(e) { console.error(e); }
})();

})();
